import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { postListExcerpt } from "../../utils/blogExcerpt";
import { getDateLocale } from "../../utils/locale";

function BlogCard({ post }) {
    const { t } = useTranslation();
    const date = new Date(post.published_at || post.created_at).toLocaleDateString(getDateLocale(), {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <motion.div
            whileHover={{ y: -6, scale: 1.01 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="h-full"
        >
            <Link to={`/blog/${post.slug}`} className="blog-card h-full">
                <div className="blog-card-img-wrap">
                    {post.featured_image_url ? (
                        <img
                            src={post.featured_image_url}
                            alt={post.title}
                            className="blog-card-img"
                        />
                    ) : (
                        <div className="blog-card-placeholder">
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 opacity-50">
                                <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                            </svg>
                        </div>
                    )}
                </div>

                <div className="blog-card-content">
                    <div className="blog-card-meta">
                        <span className="blog-card-date">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                                <path fillRule="evenodd" d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" clipRule="evenodd" />
                            </svg>
                            {date}
                        </span>
                    </div>

                    <h3 className="blog-card-title">{post.title}</h3>
                    <p className="blog-card-excerpt">
                        {postListExcerpt(post) || t("blog.noDescription")}
                    </p>

                    <div className="blog-card-readmore">
                        {t("blog.readMore")}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                            <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                        </svg>
                    </div>
                </div>
            </Link>
        </motion.div>
    );
}

export default BlogCard;
